import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {RxComponent} from '../../../../core/components/common/rx.component';
import {SmartModalService} from '../../../../core/services/smart-modal.service';
import {Subscription} from 'rxjs';

interface PricingModel {
    id?: string;
    name: string;
    sku: string;
    listPrice: string;

    currency: any;
    pricing: Array<any>;
    usdAmount: number;
    euroAmount: number;
    inrAmount: number;
    gbpAmount: number;
}

@Component({
  selector: 'itpx-create-new-price',
  templateUrl: './create-new-price.component.html',
  styleUrls: ['./create-new-price.component.css']
})
export class CreateNewPriceComponent extends RxComponent implements OnInit, OnDestroy {

    @Input() data: any;

    private productNotFound: boolean = false;
    private serviceRef: any = null;
    private editParam: any = null;
    private priceListItemDetails: any = null;
    private currenciesMap: any = {};

    private productDetails: any = null;
    private priceModel: PricingModel = <any>{};

    private sub: Subscription;

    private $showDeleteConfirmation: boolean;

    constructor(private smartModalService: SmartModalService) {
        super();
    }

    ngOnInit() {
        this.initializeData();
    }

    initializeData() {
        this.editParam = this.data.editParam;
        this.serviceRef = this.data.serviceReference;
        this.priceListItemDetails = this.data.priceListItemDetails;
        this.priceModel = this.data.priceModel || {};
        this.$showDeleteConfirmation = false;
        this.setConfigurations();
    }

    setConfigurations() {
        if (this.editParam) {
            this.priceModel.sku = this.editParam.sku;
            this.findProductBySKU();
        }
        if (this.data.currencies) {
            this.data.currencies.map(_ => {
               this.currenciesMap[_.value.replace(/\s/g, '')] = _;
            });
        }
    }

    findProductBySKU() {
        const id = this.priceListItemDetails.id;
        const sku =  this.priceModel.sku;
        this.productNotFound = false;
        this.sub = this.serviceRef.findProductBySKU(sku, id).subscribe((productDetail) => {
            this.productDetails = productDetail;
            this.productNotFound = !this.productDetails;
            this.mapExistingPricing();
        });
    }

    mapExistingPricing() {
        this.priceModel.usdAmount = undefined;
        this.priceModel.euroAmount = undefined;
        this.priceModel.inrAmount = undefined;
        this.priceModel.gbpAmount = undefined;

        if (this.productDetails && this.productDetails.pricing && this.productDetails.pricing.length) {
            this.editParam = true;
            this.productDetails.pricing.map((eachPrice) => {
                if (eachPrice.currency && eachPrice.currency.configKey === 'EUR') {
                    this.priceModel.euroAmount = eachPrice.price;
                }
                if (eachPrice.currency && eachPrice.currency.configKey === 'USD') {
                    this.priceModel.usdAmount = eachPrice.price;
                }
                if (eachPrice.currency && eachPrice.currency.configKey === 'INR') {
                    this.priceModel.inrAmount = eachPrice.price;
                }
                if (eachPrice.currency && eachPrice.currency.configKey === 'GBP') {
                    this.priceModel.gbpAmount = eachPrice.price;
                }
            });
        }
    }

    isPriceValid() {
        return this.priceModel.sku && this.priceModel.usdAmount >= 0 && this.priceModel.euroAmount >= 0 && this.priceModel.inrAmount >= 0 && this.priceModel.gbpAmount >= 0 &&
            this.priceModel.usdAmount.toString().match(/^[0-9]+(\.[0-9]{1,2})?$/) &&
            this.priceModel.euroAmount.toString().match(/^[0-9]+(\.[0-9]{1,2})?$/) &&
            this.priceModel.inrAmount.toString().match(/^[0-9]+(\.[0-9]{1,2})?$/) &&
            this.priceModel.gbpAmount.toString().match(/^[0-9]+(\.[0-9]{1,2})?$/);
    }

    prepareNewPricePayload() {
        let rawPayload : any = {};
        rawPayload.id = this.productDetails.id;
        rawPayload.name = this.productDetails.name;
        rawPayload.sku = this.priceModel.sku;
        rawPayload.listPrice = this.productDetails.listPrice;
        rawPayload.currency = {id : this.productDetails.currency.id};

        if (this.editParam) {
            rawPayload.pricing = [
                {
                    currency : {id : this.currenciesMap.USD.key},
                    price: this.priceModel.usdAmount
                },
                {
                    currency : {id : this.currenciesMap.Euro.key},
                    price: this.priceModel.euroAmount
                },
                {
                    currency : {id : this.currenciesMap['IndianRupee'].key},
                    price: this.priceModel.inrAmount
                },
                {
                    currency : {id : this.currenciesMap['PoundSterling'].key},
                    price: this.priceModel.gbpAmount
                }
            ];
            if (this.productDetails.pricing && this.productDetails.pricing.length > 0) {
                this.productDetails.pricing.map((_) => {
                    const pricingId = _.id;
                    const currencyId = _.currency.id;
                    rawPayload.pricing.map((_) => {
                        if (_.currency.id === currencyId) _.id = pricingId;
                        return _;
                    });
                    return rawPayload;

                })
            }
        } else {
            rawPayload.pricing = [
                {
                    currency : {id : this.currenciesMap.USD.key},
                    price: this.priceModel.usdAmount
                },
                {
                    currency : {id : this.currenciesMap.Euro.key},
                    price: this.priceModel.euroAmount
                },
                {
                    currency : {id : this.currenciesMap['IndianRupee'].key},
                    price: this.priceModel.inrAmount
                },
                {
                    currency : {id : this.currenciesMap['PoundSterling'].key},
                    price: this.priceModel.gbpAmount
                },
            ];
        }

        rawPayload.priceList = {id: this.priceListItemDetails.id};

        return rawPayload;
    }

    savePrice() {
        this.smartModalService.sendResult({updateOperation : !!this.editParam, createOperation : !this.editParam, payload: this.prepareNewPricePayload()});
    }

    ngOnDestroy() {
        if (this.sub) this.sub.unsubscribe();
    }

    isDeletePriceAvailable() {
        return this.editParam;
    }

    showDeleteConfirmation() {
        this.$showDeleteConfirmation = true;
    }

    hideDeleteConfirmation() {
        this.$showDeleteConfirmation = false;
    }

    deletePrice() {
        this.smartModalService.sendResult({deleteOperation : !!this.$showDeleteConfirmation, payload: this.prepareNewPricePayload()});
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/pricing/create-new-price/create-new-price.component.ts